import { api } from "@/forms/api";

const getCaptchaToken = (
  state: {
    entity: string;
    company_id: number;
    country_id: number;
  },
  el: HTMLElement
) =>
  new Promise<string>((resolve, reject) => {
    api.tr3
      .captchaCreateToken(state.entity, state.company_id, state.country_id)
      .then(({ data }) => {
        const { captcha_token, is_captcha_required } = data;

        if (!is_captcha_required) {
          resolve(captcha_token);
          return;
        }

        (window as any).initGeetest4(
          {
            captchaId: "de11216be4653c243c751c825e9c04c5",
            language: "eng",
            product: "bind"
          },
          function(captcha: any) {
            const captchaError = new Error("Captcha is not valid");

            captcha
              .appendTo(el)
              .onError(function() {
                captcha.destroy();
                reject(captchaError);
              })
              .onClose(function() {
                captcha.destroy();
                reject(captchaError);
              })
              .onSuccess(function() {
                const captchaResult = captcha.getValidate();
                captcha.destroy();

                if (!captchaResult) {
                  reject(captchaError);
                  return;
                }

                api.tr3
                  .captchaVerify(captcha_token, captchaResult)
                  .then(() => {
                    resolve(captcha_token);
                  })
                  .catch(() => {
                    reject(captchaError);
                  });
              });

            captcha.showCaptcha();
          }
        );
      });
  });

export default getCaptchaToken;
